<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class="row">
        <div class='col-lg-12' style="padding:30px">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">تغيير بيانات الملف الشخصى</h3>
            </div>
            <div class="panel-body">
              <div :class="isDanger ? 'alert-danger' : 'alert-success'" class="alert  alert-dismissable" v-if="message">
                {{message}}
              </div>
              <form role='form'>
                <div class='modal-body'>
                  <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                    <ul v-if='validationErrors'>
                      <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                    </ul>
                  </div>
                  <div class='alert alert-success alert-dismissable' v-if='successShow'>
                    {{success}}
                  </div>
                  <fieldset>
                    <div class='form-group col-lg-9 col-sm-9'>
                      <div class='form-group col-lg-6 col-sm-6'>
                        <label>الاسم:</label>
                        <input @keypress="isLocked($event)" :value='record.name' class='form-control' name='name' type='text'>
                      </div>
                      <div class='form-group col-lg-6 col-sm-6'>
                        <label>العنوان:</label>
                        <input v-model='record.address' class='form-control' name='address' type='text'>
                      </div>
                      <div class='form-group col-lg-6 col-sm-6'>
                        <label>البريد الالكترونى:</label>
                        <input v-model='record.email' class='form-control' name='email' type='text'>
                      </div>
                      <div class='form-group col-lg-6 col-sm-6'>
                        <label>التليفون:</label>
                        <input v-model='record.phone' class='form-control' name='phone' type='text'>
                      </div>
                      <div class='form-group col-lg-6 col-sm-6'>
                        <label>المحمول:</label>
                        <input v-model='record.mobile' class='form-control' name='mobile' type='text'>
                      </div>
                      <div class='form-group col-lg-4 col-sm-4'>
                        <my-upload field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        :width="300"
                        :height="300"
                        :url="url"
                        lang-type="ar"
                        :params="params"
                        :headers="headers"
                        img-format="png"></my-upload>
                        <img :src="imgDataUrl" >
                      </div>
                    </div>
                    <div class='form-group col-lg-3 col-sm-3' style="text-align: center">
                      <img :src="record.imgURL" v-bind:alt="pic" style="width: 200px;height: 200px;vertical-align: middle;padding:3px;margin:5px; border: 5px solid #555;">
                      <br>
                      <button style="padding:5px;margin:3px" @click='toggleShow' type='button' class='btn btn-outline btn-info'>تغيير الصورة</button>
                      <button style="padding:5px;margin:3px" @click='DeleteAvatar()' type='button' class='btn btn-outline btn-danger'>حذف الصورة</button>
                    </div>
                  </fieldset>
                </div>
                <div class='modal-footer'>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button v-show="$per.value.saveUserProfileInfo" @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<script>

import myUpload from 'vue-image-crop-upload/upload-2.vue'
import axios from 'axios'
export default {
  name: 'ProfileInfo',
  components: {
    'my-upload': myUpload
  },
  data () {
    return {
      url: 'https://plfilters.com/api/api/store-avatar-image',
      show: false,
      params: {
        token: localStorage.getItem('token'),
        name: 'avatar'
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '',
      validationErrors: '',
      record: {},
      message: '',
      errorShow: false,
      pic: 'profile picture',
      successShow: false,
      isLoadingSave: false
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getUserProfileInfo', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.record = data
          this.record.imgURL = 'https://plfilters.com/api/system/storage/app/av-img/' + localStorage.getItem('avt_img')
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // ==================================
    toggleShow () {
      this.show = !this.show
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess (imgDataUrl, field) {
      this.record.imgURL = imgDataUrl
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess (jsonData, field) {

    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail (status, field) {

    },
    // =========================================
    getImgUrl (pet) {
      var images = require.context('@/assets/', false, /\.png$/)
      return images('./' + pet + '.png')
    },
    // =========================================
    DeleteAvatar () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'remove-avatar-image', {
        token: localStorage.getItem('token')
      })
        .then(res => {
          this.record.imgURL = 'https://plfilters.com/api/system/storage/app/av-img/eyJ0eXAiOiJKV1QiLCJhbGciOiJI.png'
          this.isLoadingSave = false
          localStorage.setItem('avt_img', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJI.png')
        })
    },
    // =========================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =========================================
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveUserProfileInfo', {
        token: localStorage.getItem('token'),
        rec: this.record
      })
        .then(res => {
          this.isLoadingSave = false
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/ChangeProfile.vue